var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9048 6.79875C15.8436 6.79 15.7823 6.79 15.7211 6.79875C14.3648 6.755 13.2886 5.64375 13.2886 4.27875C13.2886 2.8875 14.4173 1.75 15.8173 1.75C17.2086 1.75 18.3461 2.87875 18.3461 4.27875C18.3373 5.64375 17.2611 6.755 15.9048 6.79875Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7576 12.8638C17.7776 13.5201 16.4038 13.7651 15.1351 13.5988C15.4676 12.8813 15.6426 12.0851 15.6513 11.2451C15.6513 10.3701 15.4588 9.53883 15.0913 8.81258C16.3863 8.63758 17.7601 8.88257 18.7488 9.53882C20.1313 10.4488 20.1313 11.9451 18.7576 12.8638Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.20199 6.79875C6.26324 6.79 6.32449 6.79 6.38574 6.79875C7.74199 6.755 8.81824 5.64375 8.81824 4.27875C8.81824 2.8875 7.68949 1.75 6.28949 1.75C4.89824 1.75 3.76074 2.87875 3.76074 4.27875C3.76949 5.64375 4.84574 6.755 6.20199 6.79875Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.29739 11.2452C6.29739 12.094 6.48114 12.899 6.81364 13.6252C5.57989 13.7565 4.29364 13.494 3.34864 12.8727C1.96614 11.954 1.96614 10.4577 3.34864 9.53899C4.28489 8.90899 5.60614 8.65525 6.84864 8.79525C6.48989 9.53025 6.29739 10.3615 6.29739 11.2452Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1716 13.8862C11.1016 13.8775 11.0229 13.8775 10.9441 13.8862C9.3341 13.8337 8.04785 12.5125 8.04785 10.885C8.04785 9.2225 9.3866 7.875 11.0579 7.875C12.7204 7.875 14.0679 9.2225 14.0679 10.885C14.0679 12.5125 12.7904 13.8337 11.1716 13.8862Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32834 15.7C7.00709 16.5837 7.00709 18.0362 8.32834 18.9112C9.83334 19.9175 12.3008 19.9175 13.8058 18.9112C15.1271 18.0275 15.1271 16.575 13.8058 15.7C12.3096 14.6937 9.84209 14.6937 8.32834 15.7Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon03);
export default __webpack_public_path__ + "static/media/menu-icon-03.b412e644883f58e2cd4a6c36e5ee7382.svg";
export { ForwardRef as ReactComponent };